<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row lg:justify-center items-center px-16.1 lg:px-9 xl:px-156px pt-55px pb-12 lg:pb-97 lg:pt-39.25 md:pt-16.5 col-span-full md:col-start-2 md:col-end-8 lg:col-start-1 lg:col-end-13  gap-x-14 gap-y-12"
    >
      <section class="w-full lg:w-1/2 flex flex-col md:text-left px-20px lg:px-0 " :class="{'flex-col-reverse': colReverse = Banner.textReverse, 'text-center': isMobile }">
        <p
          v-if="withBorder"
          class="text-3xl "
          v-text="Banner.title"
          :class="Banner.titleStyle"
        />
        <p
          class="pt-12 lg:pt-6 lg:w-105 xl:w-131 text-lg" :class="Banner.firstTextStyle"
         
        ><span  :class="Banner.spanStyle">{{Banner.span}}</span> {{Banner.text}} <span>{{Banner.title}}</span></p>
        <section class="pt-0 " :class="{'pt-6': Banner.firstButton }">
          <main-button v-if="Banner.firstButton" :class="Banner.buttonStyles" />
        </section>
      </section>

      <section class="w-full lg:w-1/2 max-w-133 " :class="Banner.registerStyle || { 'border-2 border-black': withBorder, } " >
        <section class=" pt-8 pb-4" :class="{ 'border-b border-black text-center': withBorder }">
          <p
            :class="Banner.registerTextStyle || { ' text-center ': withBorder}"
            class="text-3xl font-semibold"
            v-text="Banner.register"
          />
        </section>
        <ContactForm :landing="landing" :buttonStyle="Banner.buttonStyles"
          :buttonText="{buttonText:Banner.buttonText,btnText:Banner.btnText,secondText:Banner.secondText}"
        />
      </section>
    </section>
  </section>
</template>

<script>
import utilsMixin from "../mixins/utilsMixin"
import MainButton from "../components/MainButton.vue"
import ContactForm from "../components/ContactForm.vue"

export default {
  mixins: [utilsMixin],
  components: {
    MainButton,
    ContactForm
  },
  
  props:{
    Banner:{
      default: null
    },
    landing:{

    },
    withBorder: {
      default: true
    },
    buttonText:{
      default: "Boton Principal"
    },
    
  },
}
</script>